import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AdminRole } from '../repository/enums';
import { AdminRoleService } from '../services/admin-role.service';

/**
 * 관리자 역할 검사 디렉티브
 */
@Directive({
  selector: '[adminRole]',
  standalone: true,
})
export class AdminRoleDirective {
  /**
   * 뷰 컨테이너 레퍼런스 중복 동작 방지용 플래그
   */
  #hasView = false;

  /**
   * 관리자 역할
   */
  #adminRole!: AdminRole | AdminRole[];

  /**
   * 관리자 역할
   */
  @Input('adminRole')
  set adminrole(adminrole: AdminRole | AdminRole[]) {
    this.#adminRole = adminrole;
    this.updateView();
  }

  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private adminRoleService: AdminRoleService,
  ) {}

  /**
   * 화면 갱신
   */
  private updateView(): void {
    if (Array.isArray(this.#adminRole)) {
      if (!this.adminRoleService.isAvail(...this.#adminRole)) {
        this.viewContainerRef.clear();
        this.#hasView = false;
        return;
      }
    } else if (!this.adminRoleService.isAvail(this.#adminRole)) {
      this.viewContainerRef.clear();
      this.#hasView = false;
      return;
    }

    if (!this.#hasView) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
      this.#hasView = true;
    }
  }
}
